module.exports = __webpack_public_path__ + "static/img/i31_1.5f4a4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cpzy/i31_1.png
// module id = YuNr
// module chunks = 3